import React from 'react';

import EditableClue from './Clue/EditableClue';
import FixedClue from './Clue/FixedClue';
import * as Utils from '../Utils';

const clues = (props) => {
  const classes = ['clues'];
  if (!props.visible) {
    classes.push('hidden');
  }
  const processedClues = {
    across: null,
    down: null
  };
  // This is a bit messy. This component takes inputs of:
  //  - clues
  //  - answers
  // "clues" is standard ipuz, but we also need the answers here for when
  // the user is editing, so we can show placeholders in the input fields.
  ['across', 'down'].map(direction => {
    const capDir = Utils.capitalizeFirstLetter(direction);
    processedClues[direction] = props.clues[capDir].map((clue, index) => {
    const clueKey = direction+'-'+clue[0];
    const answer = props.answers[capDir][index][1];
    if (props.editable) {
      return (
        <EditableClue key={clueKey}
                      clueNumber={clue[0]}
                      answer={answer} 
                      onClueChange={(e) => {props.onClueChange(e, clueKey)}}
                      enabled={props.isComplete}>
          {clue[1]}
        </EditableClue>
      );
    } else {
      return (
        <FixedClue key={clueKey} clueNumber={clue[0]}>
          {clue[1]}
        </FixedClue>
      );
    }
    });
  });
  
  return (
    <div className={classes.join(' ')}>
      <div className="acrossColumn">
        <h3>Across</h3>
        <dl className="clueList">
          { processedClues.across }
        </dl>
      </div>
      <div className="downColumn">
        <h3>Down</h3>
        <dl className="clueList">
          { processedClues.down }
        </dl>
      </div>
    </div>
  );
};

export default clues;
